import { mainNavImages } from '@/data/pageImages';

export interface NavigationPageConfig {
  image?: string;
  color: string;
  title: string;
}

export const NAVIGATION_PAGE_CONFIGS: Record<string, NavigationPageConfig> = {
  '/': {
    title: 'Home',
    image: '/navigation/landing.png',
    color: '#F92E5F',
  },
  '/about': {
    title: 'About',
    image: mainNavImages['about']?.image,
    color: '#41142A',
  },
  '/mach': {
    title: 'Mach',
    image: mainNavImages['mach']?.image,
    color: '#F92E5F',
  },
  '/nexus': {
    title: 'Nexus',
    image: mainNavImages['nexus']?.image,
    color: '#41142A',
  },
  '/work': {
    title: 'Work',
    image: mainNavImages['work']?.image,
    color: '#160C19',
  },
  '/services': {
    title: 'Services',
    image: mainNavImages['services']?.image,
    color: '#FDD452',
  },
  '/blog': {
    title: 'Blog',
    image: mainNavImages['blog']?.image,
    color: '#160C19',
  },
  '/insights': {
    title: 'Insights',
    image: mainNavImages['insights']?.image,
    color: '#41142A',
  },
  '/methodology': {
    title: 'Methodology',
    image: mainNavImages['methodology']?.image,
    color: '#FDD452',
  },
  '/demos': {
    title: 'Demos',
    image: mainNavImages['demos']?.image,
    color: '#F92E5F',
  },
  '/key-services/replicant': {
    title: 'Replicant',
    image: '/videos/replicant-hero.mp4',
    color: '#F92E5F',
  },
};
